import MessageTextSquare from './MessageTextSquare'

export default MessageTextSquare
// eslint-disable-next-line import/export
export * from './MessageTextSquare'
